import type { CopilotScope } from "@productlane/lib/src/ai"

export const COPILOT_EMPTY_STATE_TITLE = "Assistant"

// A fresh chat from the sidebar's Assistant row. The Agent page's side panel
// ({ kind: "agent" } with no id) keeps the suggestion copy and actions.
export const isAgentHome = (scope: CopilotScope | null | undefined): boolean =>
	scope?.kind === "agent" && !!scope.chatId && !scope.recommendationId

// The Recommendations list's side panel: the agent scope with nothing open.
export const isRecommendationsOverview = (
	scope: CopilotScope | null | undefined,
): boolean =>
	scope?.kind === "agent" && !scope.chatId && !scope.recommendationId

export const copilotEmptyStateDescription = (
	scope: CopilotScope | null | undefined,
): string => {
	switch (scope?.kind) {
		case "article":
			return "Ask anything about this article."
		case "changelog":
			return "Ask anything about this changelog."
		case "reporting":
			return "Ask anything about these results."
		case "agent":
			if (isAgentHome(scope)) return "Let's make your support autonomous."
			return isRecommendationsOverview(scope)
				? "Ask where to start, or why the agent misses what it misses."
				: "Ask for changes to this suggestion."
		case "workspace":
			return "Ask anything about your inbox."
		default:
			return "Ask anything about this conversation."
	}
}

// Sits a little above true center so the intro balances the composer below it.
export const COPILOT_EMPTY_STATE_CLASSES =
	"flex h-full flex-col items-center justify-center px-6 pb-16"

// Chips above the composer, tinted so they sit on the grey panel without a card.
export const COPILOT_QUICK_ACTION_GROUP_CLASSES = "mb-2 flex flex-wrap gap-1.5"

export const COPILOT_QUICK_ACTION_ROW_CLASSES =
	"h-7 min-h-0 min-w-0 max-w-full gap-1.5 px-2.5 text-[13px] font-normal tracking-tight disabled:opacity-50"

export const COPILOT_QUICK_ACTION_ICON_CLASSES =
	"h-3.5 w-3.5 flex-none transform-gpu text-gray-500 dark:text-gray-400"
